import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";
import ProjectTag from "../../layout/partials/ProjectTag";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const ProjectDetailTop = ({
  projectName,
  projectLogoImg,
  tagNames,
  projectMainImg,
  contentMessage,
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner pb-4",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "tiles-wrap justify-content-center align-items-center px-2"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          {projectLogoImg ? (
            <div className="project-logo">
              <div className="project-detail-header">{projectName}</div>
              <div className="h-content-for-w-project-logo">
                <img
                  src={projectLogoImg}
                  alt={projectName}
                  className="w-project-logo"
                />
              </div>
            </div>
          ) : (
            <div className="project-detail-header">{projectName}</div>
          )}
          {tagNames && (
            <div className="project-tag-row mb-12">
              {tagNames.map((element, index) => (
                <ProjectTag id={index} tagName={element} />
              ))}
            </div>
          )}
          <div className={tilesClasses}>
            {projectMainImg && (
              <div
                className="tiles-item-project-img reveal-from-top"
                data-reveal-delay="100"
              >
                <div className="d-flex flex-column">
                  <div className="h-content-for-w-img-60vw">
                    <img
                      src={projectMainImg}
                      alt={projectName}
                      className="w-img-60vw"
                    />
                  </div>
                </div>
              </div>
            )}
            {contentMessage ? (
              <div className="reveal-from-top p-0 m-0" data-reveal-delay="100">
                {contentMessage}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

ProjectDetailTop.propTypes = propTypes;
ProjectDetailTop.defaultProps = defaultProps;

export default ProjectDetailTop;
